import React from 'react';
import { ResourceProps } from 'react-admin';

// Inversores. `list` es la pantalla de la consola (fase62); `show` es la ficha.
// El alta de administradores sigue sin ruta ni botón: la consola opera con un
// solo administrador (ver ADMIN_EMAIL en core/providers/auth.ts).
let resourceProps: ResourceProps = {
  name: 'users',
  list: React.lazy(() => import(/* webpackChunkName: "c-inversores" */ '../../console/pages/inversores')),
  show: React.lazy(() => import(/* webpackChunkName: "c-ficha" */ '../../console/pages/ficha')),
};

export default resourceProps;
